import * as HolderWrapperFn from './HolderWrapperFn';
import * as CoreFns from '../utilities/CoreFns';

function App(props) {

  var itemEdited = props.itemEdited;
  var className3 = props.className3;
  var cc = props.cc;
  var type = props.type;
  var cardPieces = props.cardPieces;
  var addCardPiece = props.addCardPiece;
  var sortedCardItemKeys = props.sortedCardItemKeys;
  var itemInfoPath = props.itemInfoPath;
  var width = props.width;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var setItemEdited = props.setItemEdited;

  var cardPiecesOut;
  if (itemEdited && CoreFns.goDownPath(currentList, itemEdited.path)){
    var thisEntityType = CoreFns.goDownPath(currentList, itemEdited.path).t;


    if (itemEdited.t === 'item' && thisEntityType === 'HFLEX' && type === 'CONTAINER'){
      cardPiecesOut = HolderWrapperFn.doActualWrap(sortedCardItemKeys, itemInfoPath, 'i', itemEdited, setItemEdited, currentList, organicChanges, 'hflex', cardPieces, width)
    }else if (itemEdited.t === 'item' && type === 'HFLEX'){
      if (thisEntityType === 'HFLEX'){
        cardPiecesOut = cardPieces;
      }else{
        cardPiecesOut = HolderWrapperFn.doActualWrap(sortedCardItemKeys, itemInfoPath, 'i', itemEdited, setItemEdited, currentList, organicChanges, 'item', cardPieces, '5px')        
      }
    }else{
      cardPiecesOut = cardPieces;
    }

  }else{
      cardPiecesOut = cardPieces;

  }
  return <div className={className3} style={cc} draggable={false}>{cardPiecesOut}{addCardPiece}</div>

}
//



export default App;
